export const CurrentYear = (new Date()).getFullYear();
